module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"hu":{"main":"Támogatók"},"en":{"main":"Supporters"}}')
  delete Component.options._Ctor
}
